<div class="sidebar-wrapper">
  <app-sidebar-header>
    <div smallTitle class="flex items-center justify-between w-[430px]">
      <div class="flex gap-2 items-center">
        <app-bordered-dropdown-icon
          (click)="switchViewToManageProject()"
          [isClosed]="true"
          [useAsBackButton]="true"
        ></app-bordered-dropdown-icon>
        <div>Anticipated Income</div>
      </div>
      <div
        (click)="clearAll()"
        class="clear-costs-button"
        [attr.disabled]="isLoading() === true || !anticipatedIncomes()?.length"
      >
        Clear All Incomes
      </div>
    </div>
  </app-sidebar-header>
  <div class="main-content overflow-scroll flex flex-col m-0 px-0" [ngClass]="{ 'justify-center': isLoading() }">
    @if (isLoading()) {
      <app-loading-spinner></app-loading-spinner>
    } @else {
      <form class="flex flex-col h-full" #generalForm="ngForm" role="form">
        @for (anticipatedLine of anticipatedIncomes(); track $index; let index = $index) {
          <app-general-sidebar-header [section]="true">
            <div class="flex" section>
              <div class="flex-1 uppercase text-base font-bold">Income Group {{ index + 1 }}</div>
              <span
                (click)="removeAnticipatedIncome(index)"
                class="delete-anticipated-line icon-trash-x"
                [attr.disabled]="anticipatedLine.pccos.length > 0 ? true : null"
              ></span>
            </div>
          </app-general-sidebar-header>
          <div class="flex flex-col mx-[30px] my-2">
            <app-dropdown
              class="flex-1"
              [required]="true"
              [optionLabel]="'name'"
              [optionValue]="'id'"
              [ngModel]="anticipatedLine.item_id"
              (ngModelChange)="lineItemChange($event, index)"
              placeholder="Line Item"
              label="Line Item"
              [name]="'line_item_' + (index + 1)"
              [options]="lineItems()"
              [disabledOptionIds]="disabledOptionIds()"
              [searchBar]="true"
              searchPlaceholder="Search Budget Lines..."
            >
              <ng-template #selectedContent let-option>
                <div class="flex flex-col">
                  <div class="capitalize text-navy-900 text-medium">{{ option?.name }}</div>
                  <div class="capitalize text-navy-900 font-normal">{{ option?.division }} {{ option?.cost_type }}</div>
                </div>
              </ng-template>
              <ng-template #optionContent let-option>
                <div
                  [ngClass]="{ 'disabled text-navy-500 pointer-events-none': disabledOptionIds()?.has(option.id) }"
                  class="flex flex-col text-navy-900"
                >
                  <div class="capitalize text-medium">{{ option?.name }}</div>
                  <div class="capitalize font-normal">{{ option?.division }} {{ option?.cost_type }}</div>
                </div>
              </ng-template>
            </app-dropdown>
            <div class="descriptions">
              @for (pcco of anticipatedLine?.pccos; track pcco.id; let pccoIndex = $index) {
                <div class="flex-1 flex items-center gap-2">
                  <div class="flex-1">
                    <app-floating-input
                      [(ngModel)]="pcco.number"
                      [name]="'line_item_' + (index + 1) + '_pcco_number_' + (pccoIndex + 1)"
                      [label]="'Income Description ' + (pccoIndex + 1)"
                      [placeholder]="'Income Description ' + (pccoIndex + 1)"
                      [disabled]="true"
                      [maxLength]="255"
                      [tooltipText]="pcco.title"
                    >
                    </app-floating-input>
                  </div>
                  <div class="flex-1 flex items-center gap-2">
                    <app-floating-input
                      class="flex-1"
                      [(ngModel)]="pcco.value"
                      [name]="'line_item_' + (index + 1) + '_pcco_value_' + (pccoIndex + 1)"
                      [label]="'Dollar Amount ' + (pccoIndex + 1)"
                      [placeholder]="'Dollar Amount ' + (pccoIndex + 1)"
                      [disabled]="true"
                      type="money"
                    >
                    </app-floating-input>
                    <app-add-remove-buttons
                      class="mt-3"
                      [disabledRemove]="true"
                      (addItem)="addAnticipatedIncomeDescription(index)"
                    ></app-add-remove-buttons>
                  </div>
                </div>
              }
              @for (description of anticipatedLine.modifications; track description.id; let descriptionIndex = $index) {
                <div class="flex-1 flex items-center gap-2">
                  <div class="flex-1">
                    <app-floating-input
                      [(ngModel)]="description.note"
                      [name]="'line_item_' + (index + 1) + '_description_' + (descriptionIndex + 1)"
                      [label]="'PCCO Description ' + ((anticipatedLine?.pccos.length ?? 0) + descriptionIndex + 1)"
                      [placeholder]="
                        'PCCO Description ' + ((anticipatedLine?.pccos.length ?? 0) + descriptionIndex + 1)
                      "
                      [required]="true"
                      [maxLength]="255"
                    >
                    </app-floating-input>
                  </div>
                  <div class="flex-1 flex items-center gap-2">
                    <app-floating-input
                      [name]="'line_item_' + (index + 1) + '_value_' + (descriptionIndex + 1)"
                      [(ngModel)]="description.value"
                      (ngModelChange)="onValueChange()"
                      label="Dollar Amount"
                      placeholder="Dollar Amount"
                      type="money"
                      [required]="true"
                    >
                    </app-floating-input>

                    <app-add-remove-buttons
                      class="mt-3"
                      [disabledAdd]="anticipatedIncomes().length >= lineItems().length"
                      (removeItem)="removeAnticipatedIncomeDescription(index, descriptionIndex)"
                      (addItem)="addAnticipatedIncomeDescription(index, descriptionIndex)"
                    ></app-add-remove-buttons>
                  </div>
                </div>
              }
            </div>
          </div>
        } @empty {
          <div class="flex flex-col items-center gap-4">
            <div class="text-navy-500 text-base">There's no Anticipated Income added to this project.</div>
          </div>
        }
        <div class="px-7 mx-0.5 pb-8">
          <app-simple-button
            size="large"
            [wrapperClass]="{
              'w-full bg-color-white border rounded border-solid border-blue-700 text-blue-700 text-sm font-semibold': true,
            }"
            class="flex mt-2.5"
            (click)="addAnticipatedIncome()"
          >
            Add Income Group
          </app-simple-button>
        </div>
      </form>
    }
  </div>
  <div class="buttons flex items-center gap-4">
    <div class="flex justify-between items-center flex-1 text-navy-900 font-bold">
      <div>Total</div>
      <div [ngClass]="{ negative: total() < 0 }">{{ total() | money: 'positiveComa' }}</div>
    </div>
    <app-simple-button (click)="save()" buttonStyle="color_accent_filled">Save</app-simple-button>
  </div>
</div>
